export default class FormQuestionDomainService {
    static fromJSON(json) {
        return {
            // @ts-expect-error - TS2322 - Type '{ data: any; }' is not assignable to type 'FormQuestion'.
            data: json,
        };
    }
    static get firstName() {
        return {
            id: 1,
            label: "First Name",
        };
    }
    static get middleName() {
        return {
            id: 2,
            label: "Middle Name",
        };
    }
    static get lastName() {
        return {
            id: 3,
            label: "Last Name",
        };
    }
    static get emailAddress() {
        return {
            id: 4,
            label: "Email Address",
        };
    }
    static get shortAnswer() {
        return {
            id: 5,
            label: "Short Answer",
        };
    }
    static get intendedStartTerm() {
        return {
            id: 6,
            label: "Intended Start Term",
        };
    }
    static get programInterest() {
        return {
            id: 7,
            label: "Program Interest",
        };
    }
    static get paragraph() {
        return {
            id: 9,
            label: "Paragraph",
        };
    }
    static get highSchool() {
        return {
            id: 10,
            label: "High School",
        };
    }
    static get gender() {
        return {
            id: 11,
            label: "Gender",
        };
    }
    static get race() {
        return {
            id: 12,
            label: "Race",
        };
    }
    static get ethnicity() {
        return {
            id: 13,
            label: "Ethnicity",
        };
    }
    static get birthdate() {
        return {
            id: 14,
            label: "Birthdate",
        };
    }
    static get address() {
        return {
            id: 15,
            label: "Address",
        };
    }
    static get phoneNumber() {
        return {
            id: 16,
            label: "Phone Number",
        };
    }
    static get departmentInterest() {
        return {
            id: 17,
            label: "Department Interest",
        };
    }
}
